export default "__VITE_ASSET__j9vD0dqW__"